import { accountSelectedSelector } from 'atoms';
import dayjs from 'dayjs';
import { useTimelineDescription } from 'hooks';
import React from 'react';
import { TFunction, Namespace } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Column } from 'types/table.types';
import { TimelineToPrint, TimelineTypeEnum } from 'types/timeline.types';

function useEventsColumns({
  t,
}: {
  t: TFunction<Namespace<'_common'>>;
}): Column<TimelineToPrint>[] {
  const accountSelected = useRecoilValue(accountSelectedSelector);
  return React.useMemo(() => {
    const codeColumn: Column<TimelineToPrint> = {
      description: t('_common:event'),
      dataKey: 'code',
    };
    const partitionColumn: Column<TimelineToPrint> = {
      description: t('_common:partition'),
      dataKey: 'partitionCode',
      renderValue: (_, row) =>
        [row.partitionCode, row.partitionDescription].filter(Boolean).join(' - ') ?? '',
    };
    const accountCodeColumn: Column<TimelineToPrint> = {
      description: t('_common:account_code'),
      // @ts-ignore
      dataKey: 'accountCode',
    };
    const accountNameColumn: Column<TimelineToPrint> = {
      description: t('_common:account_name'),
      // @ts-ignore
      dataKey: 'accountName',
    };
    const descriptionColumn: Column<TimelineToPrint> = {
      description: t('_common:description'),
      dataKey: 'description',
      renderValue: (_, row) =>
        `${useTimelineDescription.getTitle(row, t)}${
          row.type === TimelineTypeEnum.LOG ? ` - ${row.description}` : ''
        }`,
    };
    const auxiliaryColumn: Column<TimelineToPrint> = {
      description: t('_common:auxiliary'),
      dataKey: 'auxiliary',
    };
    const dateColumn: Column<TimelineToPrint> = {
      description: t('_common:date'),
      dataKey: 'date',
      renderValue: (value) => dayjs(value).format('LLL'),
    };

    const observationsColumn: Column<TimelineToPrint> = {
      description: t('_common:observations'),
      dataKey: 'observation',
    };

    return accountSelected
      ? [
          codeColumn,
          auxiliaryColumn,
          partitionColumn,
          descriptionColumn,
          dateColumn,
          observationsColumn,
        ]
      : [
          accountCodeColumn,
          accountNameColumn,
          codeColumn,
          auxiliaryColumn,
          partitionColumn,
          descriptionColumn,
          dateColumn,
          observationsColumn,
        ];
  }, [accountSelected, t]);
}

export default useEventsColumns;
